(() => {
  const BR_SECTION = 'br-cart-icon-bubble';

  function patch(proto) {
    if (!proto?.getSectionsToRender || proto.__brCartPatched) return;

    const original = proto.getSectionsToRender;

    proto.getSectionsToRender = function () {
      return original.call(this).map(section =>
        section.id === 'cart-icon-bubble'
          ? { ...section, section: BR_SECTION }
          : section
      );
    };

    proto.__brCartPatched = true;
  }

  const patchCart = () => {
    patch(customElements.get('cart-items')?.prototype);
    patch(customElements.get('cart-drawer-items')?.prototype);
    patch(customElements.get('cart-drawer')?.prototype);
    patch(customElements.get('cart-notification')?.prototype);
    patch(customElements.get('quick-add-bulk')?.prototype);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCart, { once: true });
  } else {
    patchCart();
  }
})();